"use client";

import { Box, BoxProps } from "@chakra-ui/react";
import React from "react";

interface MainContainerPrivateProps extends BoxProps {
  children: React.ReactNode;
}

export function MainContainerPrivate({
  children,
  ...props
}: MainContainerPrivateProps) {
  return (
    <Box
      as="main"
      width="full"
      minH="dvh"
      bg="moveon.bg"
      color="fg"
      paddingX={{
        base: "4",
        sm: "4",
        md: "12",
        lg: "24",
      }}
      {...props} // Allow overriding default props
    >
      {children}
    </Box>
  );
}

interface MainContainerPublicProps {
  children: React.ReactNode;
  className?: string;
}

//! applied to auth-related pages only. Other public pages do have their own layouts...
export function MainContainerPublic({
  children,
  className = "",
  ...props
}: MainContainerPublicProps) {
  return (
    <main
      className={`w-full min-h-dvh bg-white text-gray-900 px-4 sm:px-4 md:px-12 lg:px-24 ${className}`}
      {...props}
    >
      {children}
    </main>
  );
}
